import React, { Component } from "react";
import TextMessage from "./TextMessage";
import EmojiMessage from "./EmojiMessage";
import FileMessage from "./FileMessage";
import chatIconUrl from "./../../assets/responsum_logo.png";

import { getUserDisplayName } from "../../../../../../utils";
import Launcher from "../Launcher";

class Message extends Component {
  _renderMessageOfType(type) {
    switch (type) {
      case "text":
        return <TextMessage {...this.props.message} />;
      case "emoji":
        return <EmojiMessage {...this.props.message} />;
      case "file":
        return <FileMessage {...this.props.message} />;
      default:
        console.error(`Attempting to load message with unsupported file type '${type}'`);
    }
  }

  render() {
    let contentClassList = ["sc-message--content", this.props.message.author === "me" ? "sent" : "received"];
    const imgCss = {
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      alignSelf: "center",
      marginRight: "0",
      marginLeft: "0"
    };

    return (
      <div className="sc-message">
        <div className={contentClassList.join(" ")}>
          {this.props.message.author === "me" ? "" : <div className="sc-message--avatar them" />}

          {this._renderMessageOfType(this.props.message.type)}

          {/*{this.props.message.author === "me" ? <div className="sc-message--avatar sent" /> : ""}*/}
          {this.props.message.author === "me" ? (
            <div className="sc-message--avatar me">
              {/*<img src={this.props.userImage} alt={} className={imgCss} />*/}
              <img src={this.props.userImage} alt={`${this.props.userFullName} profile image`} style={imgCss} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default Message;
